import React, { useState } from 'react'
import { Widget, WidgetContent, Divider, TextField } from '@duik/it'
import ChangePassword from './ChangePassword'
import CloseIcon from '@material-ui/icons/ClearRounded'
import { Formik, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import { ModalButton } from '../UI/ModalButton'
import FormInputGroup from '../UI/FormInputGroup'

const ProfileModal = props => {
  const [profileScreen, setProfileScreen] = useState('profile')

  return (
    <div
      style={{
        position: 'fixed',
        top: '0',
        left: '0',
        height: '100%',
        width: '100%',
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1
      }}
    >
      <div
        style={{
          maxWidth: '540px',
          maxHeight: '591px',
          width: '100%',
          height: '100%',
          backgroundColor: 'white',
          borderRadius: '5px'
        }}
        // className="roll-in-left"
      >
        {(profileScreen === 'profile' || profileScreen === 'edit') && (
          <Widget>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <h3 style={{ margin: '25px' }}>
                {profileScreen === 'profile' && 'My'}
                {profileScreen === 'edit' && 'Edit'} Profile
              </h3>
              <CloseIcon onClick={props.profileModalToggle} className="closeIcon" />
            </div>

            <Divider />
            <Formik
              initialValues={{
                firstName: props.userData.firstName,
                lastName: props.userData.lastName,
                email: props.userData.email,
                password: '',
                passwordNew1: '',
                passwordNew2: ''
              }}
              validationSchema={ProfileSchema}
              handleSubmit={e => console.log(e)}
              onSubmit={values => {
                // createNewContact(values)
                console.log(values)
              }}
              render={({ values, handleBlur, handleChange, handleSubmit, isSubmitting }) => (
                <form>
                  <WidgetContent style={{ height: '386px' }}>
                    <FormInputGroup direction="horizontal">
                      <div>
                        <TextField
                          className="halfWidthInputBox"
                          label="FIRST NAME"
                          name="firstName"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.firstName}
                          disabled={profileScreen === 'profile'}
                        />
                        <ErrorMessage
                          name="company"
                          render={msg => (
                            <span
                              style={{
                                position: 'absolute',
                                color: '#E6492D',
                                fontSize: '0.75rem'
                              }}
                            >
                              {msg}
                            </span>
                          )}
                        />
                      </div>
                      <div>
                        <TextField
                          className="halfWidthInputBox"
                          label="LAST NAME"
                          name="lastName"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.lastName}
                          disabled={profileScreen === 'profile'}
                        />
                        <ErrorMessage
                          name="company"
                          render={msg => (
                            <span
                              style={{
                                position: 'absolute',
                                color: '#E6492D',
                                fontSize: '0.75rem'
                              }}
                            >
                              {msg}
                            </span>
                          )}
                        />
                      </div>
                    </FormInputGroup>
                    <FormInputGroup>
                      <FormInputGroup horizontal>
                        <div style={{ margin: '10px 0' }}>
                          <TextField
                            className="fullWidthInputBox"
                            label="E-MAIL ADDRESS"
                            name="email"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                            disabled={profileScreen === 'profile'}
                          />
                        </div>
                      </FormInputGroup>
                      <FormInputGroup horizontal>
                        <div style={{ position: 'relative' }}>
                          <div
                            style={{
                              position: 'absolute',
                              right: 0
                            }}
                          >
                            {profileScreen === 'edit' && (
                              <div onClick={() => setProfileScreen('password')}>
                                <span
                                  className="cursor-pointer"
                                  style={{ color: '#289c91', fontSize: '12px' }}
                                >
                                  Change Password
                                </span>
                              </div>
                            )}
                          </div>
                          <TextField
                            className="fullWidthInputBox"
                            label="PASSWORD"
                            name="password"
                            type="password"
                            placeholder="··········"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            disabled
                            // value={values.password}
                          />
                          <ErrorMessage
                            name="password"
                            render={msg => (
                              <span
                                style={{
                                  position: 'absolute',
                                  color: '#E6492D',
                                  fontSize: '0.75rem'
                                }}
                              >
                                {msg}
                              </span>
                            )}
                          />
                        </div>
                      </FormInputGroup>
                      {/* <FormInputGroup horizontal>
                        <div>
                          <TextField
                            className="fullWidthInputBox"
                            label="New Password"
                            name="passwordNew1"
                            type="password"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.passwordNew1}
                          />
                          <ErrorMessage
                            name="passwordNew1"
                            render={msg => (
                              <span
                                style={{
                                  position: 'absolute',
                                  color: '#E6492D',
                                  fontSize: '0.75rem'
                                }}
                              >
                                {msg}
                              </span>
                            )}
                          />
                        </div>
                      </FormInputGroup>
                      <FormInputGroup horizontal>
                        <div>
                          <TextField
                            className="fullWidthInputBox"
                            label="Confirm New Password"
                            name="passwordNew2"
                            type="password"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.passwordNew2}
                          />
                          <ErrorMessage
                            name="passwordNew2"
                            render={msg => (
                              <span
                                style={{
                                  position: 'absolute',
                                  color: '#E6492D',
                                  fontSize: '0.75rem'
                                }}
                              >
                                {msg}
                              </span>
                            )}
                          />
                        </div>
                      </FormInputGroup> */}
                    </FormInputGroup>
                  </WidgetContent>
                  {/* <UikDivider /> */}

                  <WidgetContent style={{ display: 'flex', justifyContent: 'space-between' }}>
                    {profileScreen === 'profile' && (
                      <div style={{ width: '83px' }}>
                        <ModalButton
                          buttonStyle="tertiary"
                          name="Edit"
                          onClick={() => setProfileScreen('edit')}
                        />
                      </div>
                    )}
                    {profileScreen === 'edit' && (
                      <div style={{ width: '83px' }}>
                        <ModalButton
                          buttonStyle="tertiary"
                          name="Cancel"
                          onClick={() => setProfileScreen('profile')}
                        />
                      </div>
                    )}
                    {profileScreen === 'profile' && (
                      <div style={{ width: '83px' }}>
                        <ModalButton
                          buttonStyle="tertiary"
                          onClick={props.profileModalToggle}
                          name="OK"
                        />
                      </div>
                    )}
                    {profileScreen === 'edit' && (
                      <div style={{ width: '83px' }}>
                        <ModalButton
                          buttonStyle="tertiary"
                          onClick={props.profileModalToggle}
                          name="Save"
                        />
                      </div>
                    )}
                  </WidgetContent>
                </form>
              )}
            />
          </Widget>
        )}
        {profileScreen === 'password' && <ChangePassword setProfileScreen={setProfileScreen} />}
      </div>
    </div>
  )
}

export default ProfileModal

const ProfileSchema = Yup.object().shape({
  firstName: Yup.string()
    .min(2, 'Too Short!')
    .max(30, 'Too Long!')
    .required('Required'),
  lastName: Yup.string()
    .min(1, 'Too Short!')
    .max(30, 'Too Long!')
    .required('Required'),
  email: Yup.string()
    .email('Invalid email')
    .required('Required'),
  password: Yup.string()
    .min(6, 'Min 6 characters')
    .max(10, 'Too Long!')
    .required('Required'),
  passwordNew1: Yup.string()
    .min(6, 'Min 6 characters')
    .max(15, 'Max 15 characters')
    .required('Required'),
  passwordNew2: Yup.string()
    .min(6, 'Min 6 characters')
    .max(15, 'Max 15 characters')
    .required('Required')
    .oneOf([Yup.ref('passwordNew1'), null], "Passwords don't match")
})
